import { createSlice } from '@reduxjs/toolkit'
import { TableColumnState } from '../types/tableColumn.types'

const initialState: TableColumnState = {
  tableColumn: {},
}

const tableColumnSlice = createSlice({
  name: 'tableColumn',
  initialState: initialState,
  reducers: {
    updateTableColumns: (state: TableColumnState, action) => {
      if (action?.payload?.tableName && action?.payload?.tableColumns) {
        state.tableColumn[action?.payload?.tableName] =
          action?.payload?.tableColumns
      }
    },
  },
})

export const { updateTableColumns } = tableColumnSlice.actions
export default tableColumnSlice.reducer
